import { render, staticRenderFns } from "./Trip.vue?vue&type=template&id=2712e8f2&scoped=true&"
import script from "./Trip.vue?vue&type=script&lang=ts&"
export * from "./Trip.vue?vue&type=script&lang=ts&"
import style0 from "./Trip.vue?vue&type=style&index=0&id=2712e8f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2712e8f2",
  null
  
)

export default component.exports